const G = "#b8960c";
const NAV_LINKS = ["About", "Projects", "GitHub", "Services", "Experience", "Contact"];

export default function Navbar({ active, menuOpen, setMenuOpen, goTo }) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/8" style={{ background: "#0f0f0fF5", backdropFilter: "blur(12px)" }}>
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between h-14">
        <div style={{ fontFamily: 'Playfair Display, serif', color: "white" }} className="font-black text-lg">
          W<span style={{ color: G }}>.</span>O
        </div>
        <div className="hidden md:flex gap-1">
          {NAV_LINKS.map(l => (
            <button key={l} onClick={() => goTo(l)}
              className="text-xs px-3 py-1.5 rounded transition-all tracking-wide font-medium"
              style={{ color: active === l ? G : "#666", borderBottom: active === l ? `2px solid ${G}` : "2px solid transparent" }}>
              {l}
            </button>
          ))}
        </div>
        <button className="md:hidden flex flex-col gap-1.5 p-2" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="w-5 h-0.5 bg-white" />
          <div className="w-5 h-0.5 bg-white" />
          <div className="w-5 h-0.5 bg-white" />
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden border-t border-white/8 px-4 py-4 flex flex-col gap-4" style={{ background: "#0f0f0f" }}>
          {NAV_LINKS.map(l => (
            <button key={l} onClick={() => goTo(l)}
              className="text-sm text-left font-medium py-1 border-b border-white/5"
              style={{ color: active === l ? G : "#888" }}>
              {l}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}